import donut from '../images/donut.png'

const data = [
    {
        id: 1,
        img: donut,
        title: 'Donut models and animation',
        description: "Designed and animated a donut model using Blender. The donut is animated to rotate and scale, creating a visually appealing effect.",
        url: "https://drive.google.com/drive/folders/1st5E92IlwtAO3aT-BB8tWKuD3hoBCthH?usp=sharing",
        date: "2025/May/4"
    }
]
export default data